import React, { useRef } from 'react';
import './Contact.css';
import emailjs from '@emailjs/browser';
import swal from 'sweetalert';

const Contact = () => {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs.sendForm('service_fnsry35', 'template_ae7881u', form.current, 'user_0Kc8zc4YB4JqkU2TwdasG')
            .then((result) => {
                console.log(result.text);
                if (result.text === "OK") {
                    swal({
                        title: "Thank you!",
                        text: "I got your message. I will contact you soon",
                        icon: "success",
                    });
                }
            }, (error) => {
                swal({
                    title: "Something is wrong!",
                    text: (error.message),
                    icon: "error",
                });
            });
        form.current.reset();
    }
    return (
        <div className='contact-page'>
            <div className="contact-header">
                <p className="contact-header-p-1">Contact</p>
                <p className="contact-header-p-2">Get In Touch</p>
            </div>

            <div className="form" >
                <form ref={form} onSubmit={sendEmail}>
                    <input type="text" placeholder="Your name" required name="name" /> <br /> 
                    
                    <input type="text" placeholder="subject" name="subject" required /> <br />

                    <input type="email" placeholder="your email" required name="email" /> <br />

                    <textarea name="message" placeholder="write message" required id="" cols="39" rows="5" ></textarea> <br />
                    <input className="email-btn" type="submit" value="Send Email" />
                </form>
            </div>

        </div>
    );
};

export default Contact;